module.exports = "mutation ($data: ShopCreate!) {\n  ShopCreate(data: $data) {\n    id\n  }\n}\n"